export class Provider{
    get(){}
    configure(){}
}